var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_vm._v(" 푸시 알림 테스트 페이지 "),_c('br'),_c('br'),_c('button',{on:{"click":_vm.getPushToken}},[_vm._v("토큰가져오기!")]),_c('br'),_c('br'),_c('button',{on:{"click":_vm.sendPush}},[_vm._v("발송!")])])}
var staticRenderFns = []

export { render, staticRenderFns }